import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { API } from "../../common/model/objectTypes";
import { returnsInfo } from "../../utils/apiDescription/ssr/returns";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { appendReturnRequestBody, baseResponseWithTaxReturnIdResponseBody, fetchReturnResponseBody, partialUploadRequestBody, recognizeReturnRequestBody, requiredTaxReturnIdParameter, setAccessRequestBody, unRecognizedReturnResponseBody, uploadRequestBody, uploadedResponseBody } from "../../utils/ssr/apiObjects";
import { appendJsonRequestCurl, fetchReturnDetailsJsonRequestCurl, partialUploadJsonRequestCurl, recognizeReturnJsonRequestCurl, setAccessJsonRequestCurl, unRecognizedReturnsJsonRequestCurl, uploadJsonRequestCurl, uploadedReturnsJsonRequestCurl } from "../../utils/ssr/sampleJsonRequest";
import { appendJsonResponse, fetchReturnJsonResponse, partialUploadJsonResponse, recognizeReturnRequestJsonResponse, unRecognizedReturnJsonResponse, uploadJsonResponse, uploadedReturnsJsonResponse } from "../../utils/ssr/sampleJsonResponse";

const Append : API = {
  name : "Append",
  url : `${API_BASE_URL}/${SSR.RETURNS.APPEND_URL}`,
  method : "POST",
  headers : commonRequestHeader,
  apiInfo : returnsInfo.append,
  requestBody : appendReturnRequestBody,
  responseBody : baseResponseWithTaxReturnIdResponseBody,
  jsonRequest : appendJsonRequestCurl,
  jsonResponse : appendJsonResponse
}

const FetchReturnDetails : API = {
  name : "Fetch Return Details",
  url : `${API_BASE_URL}/${SSR.RETURNS.FETCH_RETURN_DETAILS_URL}`,
  method : "GET",
  headers : commonRequestHeader,
  apiInfo : returnsInfo.fetchReturnDetails,
  requestBody : requiredTaxReturnIdParameter,
  responseBody : fetchReturnResponseBody,
  jsonRequest : fetchReturnDetailsJsonRequestCurl,
  jsonResponse : fetchReturnJsonResponse
} 

const PartialUpload : API = {
  name : "Partial Upload",
  url : `${API_BASE_URL}/${SSR.RETURNS.PARTIAL_UPLOAD_URL}`,
  method : "POST",
  headers : commonRequestHeader,
  apiInfo : returnsInfo.partialUpload,
  requestBody : partialUploadRequestBody,
  responseBody : baseResponseWithTaxReturnIdResponseBody,
  jsonRequest : partialUploadJsonRequestCurl,
  jsonResponse : partialUploadJsonResponse
}

const Recognize : API = {
  name : "Recognize",
  url : `${API_BASE_URL}/${SSR.RETURNS.RECOGNIZE_URL}`,
  method : "POST",
  headers : requestHeaderWithCallback,
  apiInfo : returnsInfo.recognize,
  requestBody : recognizeReturnRequestBody,
  responseBody : baseResponseWithTaxReturnIdResponseBody,
  jsonRequest : recognizeReturnJsonRequestCurl,
  jsonResponse : recognizeReturnRequestJsonResponse
}

const SetAccess : API = {
  name : "Set Access",
  url : `${API_BASE_URL}/${SSR.RETURNS.SET_ACCESS_URL}`,
  method : "PUT",
  headers : commonRequestHeader,
  apiInfo : returnsInfo.setAccess,
  requestBody : setAccessRequestBody,
  responseBody : commonResponseBody,
  jsonRequest : setAccessJsonRequestCurl,
  jsonResponse : createCommonJsonResponseWithData(200)
}

const UnRecognizedReturns : API = {
  name : "Unrecognized Returns",
  url : `${API_BASE_URL}/${SSR.RETURNS.UN_RECOGNIZED_RETURNS_URL}`,
  method : "GET",
  headers : commonRequestHeader,
  apiInfo : returnsInfo.unRecognizedReturns,
  responseBody : unRecognizedReturnResponseBody,
  jsonRequest : unRecognizedReturnsJsonRequestCurl,
  jsonResponse : unRecognizedReturnJsonResponse
}

const Upload : API = {
  name : "Upload",
  url : `${API_BASE_URL}/${SSR.RETURNS.UPLOAD_URL}`,
  method : "POST",
  headers : requestHeaderWithCallback,
  apiInfo : returnsInfo.upload,
  requestBody : uploadRequestBody,
  responseBody : baseResponseWithTaxReturnIdResponseBody,
  jsonRequest : uploadJsonRequestCurl,
  jsonResponse : uploadJsonResponse
}

const UploadedReturns : API = {
  name : "Uploaded Returns",
  url : `${API_BASE_URL}/${SSR.RETURNS.UPLOADED_RETURNS_URL}`,
  method : "GET",
  headers : commonRequestHeader,
  apiInfo : returnsInfo.uploadedReturns,
  responseBody : uploadedResponseBody,
  jsonRequest : uploadedReturnsJsonRequestCurl,
  jsonResponse : uploadedReturnsJsonResponse
}

export const getContent = (apiName :string) => {    
  switch (apiName) {
      case 'Append':
          return Append;
      case 'Fetch Return Details':
          return FetchReturnDetails;
      case 'Partial Upload':
          return PartialUpload;
      case 'Recognize':
          return Recognize;   
      case 'Set Access':
          return SetAccess;
      case 'Unrecognized Returns':
          return UnRecognizedReturns; 
      case 'Upload':
            return Upload;  
     case 'Uploaded Returns':
            return UploadedReturns;   
  }
}
